import { render, staticRenderFns } from "./generalView.vue?vue&type=template&id=2148885e&scoped=true"
import script from "./generalView.vue?vue&type=script&lang=js"
export * from "./generalView.vue?vue&type=script&lang=js"
import style0 from "./generalView.vue?vue&type=style&index=0&id=2148885e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148885e",
  null
  
)

export default component.exports